import type { FC, ReactNode } from 'react'

import { SplitText } from '@/components/motion/split-text'
import { Reveal } from '@/components/motion/reveal'
import { SectionHeading } from '@/components/site/section-heading'
import { projectScopes, scopeIntro } from '@/constants/work'

export const WorkApproach: FC = (): ReactNode => {
    return (
        <section
            id='approach'
            className='relative z-[2] flex w-full flex-col gap-10 overflow-clip bg-background px-4 pb-[120px] lg:gap-12 lg:px-6'
        >
            <SectionHeading lead="How it" title="runs" align='right' />

            <div className='flex w-full flex-col md:flex-row md:items-start md:justify-center md:gap-6'>
                <div className='flex w-full flex-col py-6 pr-6 md:max-w-[32%] md:flex-1 md:self-stretch'>
                    <h3 className='t-label max-w-[400px] text-left text-foreground'>
                        What to expect
                    </h3>
                </div>

                <div className='flex w-full flex-col py-6 pr-6 md:flex-1'>
                    <SplitText
                        as='p'
                        text={scopeIntro}
                        effect='blur'
                        stagger={0.008}
                        className='t-statement w-full max-w-full text-left text-foreground [text-wrap:balance] md:max-w-[90%]'
                    />
                </div>
            </div>

            <div className='flex w-full justify-end gap-6'>
                <div aria-hidden='true' className='hidden max-w-[32%] flex-1 lg:block' />

                <div className='w-full lg:flex-1'>
                    <div className='hidden grid-cols-[minmax(0,1fr)_minmax(0,1.3fr)_minmax(0,0.7fr)_minmax(0,0.7fr)] gap-6 border-b border-border pb-4 text-foreground md:grid'>
                        <span className='t-italic text-left'>
                            Discipline
                        </span>

                        <span className='t-italic text-left'>
                            Typical scope
                        </span>

                        <span className='t-italic text-left'>
                            Timeline
                        </span>

                        <span className='t-italic text-left'>
                            Team
                        </span>
                    </div>

                    <ul className='flex w-full flex-col'>
                        {projectScopes.map((item, index) => (
                            <li key={item.discipline} className='border-b border-border'>
                                <Reveal y={60} delay={index * 0.05}>
                                    <div className='grid grid-cols-2 gap-x-6 gap-y-3 py-6 text-foreground md:grid-cols-[minmax(0,1fr)_minmax(0,1.3fr)_minmax(0,0.7fr)_minmax(0,0.7fr)] md:gap-6'>
                                        <p className='t-label col-span-2 text-left md:col-span-1'>
                                            {item.discipline}
                                        </p>

                                        <p className='t-body col-span-2 text-left text-muted-foreground md:col-span-1'>
                                            {item.scope}
                                        </p>

                                        <p className='t-body text-left'>
                                            <span className='t-meta mr-2 md:hidden'>
                                                Timeline
                                            </span>

                                            {item.timeline}
                                        </p>

                                        <p className='t-body text-left'>
                                            <span className='t-meta mr-2 md:hidden'>
                                                Team
                                            </span>

                                            {item.team}
                                        </p>
                                    </div>
                                </Reveal>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    )
}
